import { buildExportQueryStringFromParams } from './serviceTaskExport';

/** Polia pre `print_columns` – musia sedieť s `SupportTicketController::supportTicketPrintColumnsDefault`. */
export const SUPPORT_TICKET_PRINT_COLUMNS_ALLOWED = [
  'id',
  'type',
  'defined_id',
  'theme',
  'status',
  'priority',
  'mask_number',
  'created_at_print',
  'updated_at_print',
  'waiting_for_action_by_print',
  'is_unread_label',
];

export function buildSupportTicketExportQueryStringFromParams(params = {}, opts = {}) {
  return buildExportQueryStringFromParams(params, opts);
}

/**
 * Poradie stĺpcov pre tlač z viditeľnosti UI.
 */
export function getSupportTicketPrintColumnOrder(getTable, columnsVisible) {
  const allowedSet = new Set(SUPPORT_TICKET_PRINT_COLUMNS_ALLOWED);
  const fallback = () =>
    SUPPORT_TICKET_PRINT_COLUMNS_ALLOWED.filter((k) => {
      if (k === 'id') return true;
      if (k === 'created_at_print') return columnsVisible?.created_at !== false;
      if (k === 'updated_at_print') return columnsVisible?.updated_at !== false;
      if (k === 'waiting_for_action_by_print') return columnsVisible?.waiting_for_action_by !== false;
      if (k === 'is_unread_label') return columnsVisible?.is_unread !== false;
      const map = {
        id: 'id',
        type: 'type',
        defined_id: 'defined_id',
        theme: 'theme',
        status: 'status',
        priority: 'priority',
        mask_number: 'mask_number',
      };
      const ui = map[k];
      return ui ? columnsVisible?.[ui] !== false : true;
    });

  const table = typeof getTable === 'function' ? getTable() : getTable;
  if (!table?.getColumns) return fallback();

  const out = [];
  const seen = new Set();
  const push = (apiField) => {
    if (!allowedSet.has(apiField) || seen.has(apiField)) return;
    seen.add(apiField);
    out.push(apiField);
  };
  try {
    // Keep DB ID always included for print/export traceability.
    push('id');
    for (const col of table.getColumns()) {
      const field = col.getField?.() ?? col.getDefinition?.()?.field;
      if (!field || field === 'editor' || field === 'custom_delete' || field === 'contractor_id') continue;
      if (columnsVisible?.[field] === false) continue;
      try {
        if (col.isVisible?.() === false) continue;
      } catch (_) {}

      if (field === 'created_at') {
        push('created_at_print');
      } else if (field === 'updated_at') {
        push('updated_at_print');
      } else if (field === 'waiting_for_action_by') {
        push('waiting_for_action_by_print');
      } else if (field === 'is_unread') {
        push('is_unread_label');
      } else {
        push(field);
      }
    }
  } catch (_) {
    return fallback();
  }

  return out.length > 0 ? out : fallback();
}
